module.exports = __webpack_public_path__ + "img/barBg6.929cd5d7.png";